import { render, staticRenderFns } from "./SettingsDomainDns.vue?vue&type=template&id=7215941a&scoped=true"
import script from "./SettingsDomainDns.vue?vue&type=script&lang=js"
export * from "./SettingsDomainDns.vue?vue&type=script&lang=js"
import style0 from "./SettingsDomainDns.vue?vue&type=style&index=0&id=7215941a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215941a",
  null
  
)

export default component.exports